import { SubTitle, Text } from "../Typography"
import { StyleProps, CSS } from "../styles"
import { Box } from "../Box"
import { ErrorFill } from "../Icons"

const root = (props: StyleProps): CSS => ({
  height: `200px`,
  borderLeft: `solid 2px ${props.theme.palette.grey.light}`,
  borderBottom: `solid 2px ${props.theme.palette.grey.light}`,
  padding: props.theme.spacing(6),
})

const marginVertical = (props: StyleProps): CSS => ({
  marginTop: props.theme.spacing(2),
  marginBottom: props.theme.spacing(2),
})

type Props = {
  title: string
  description: string
  dataTestId?: string
  showAxis?: boolean
}

export const EmptyChart = ({ title, description, dataTestId, showAxis }: Props) => (
  <Box data-testid={dataTestId} css={showAxis ? root : undefined}>
    <ErrorFill />
    <SubTitle css={marginVertical}>{title}</SubTitle>
    <Text>{description}</Text>
  </Box>
)

EmptyChart.defaultProps = {
  dataTestId: undefined,
  showAxis: true,
}
